import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="py-8 mt-20 border-t sm:py-12 bg-gradient-to-r from-blue-400 via-blue-300 to-secondary backdrop-blur-md border-white/10">
      <div className="flex flex-col items-center justify-between max-w-5xl gap-4 px-4 mx-auto text-center sm:px-6 sm:flex-row sm:gap-6 sm:text-left">
        <div>
          <p className="mb-2 text-sm font-medium text-white sm:text-base">Made by yabu</p>
          <p className="text-xs text-gray-300 sm:text-sm">&copy; {currentYear} yabu. All rights reserved.</p>
        </div>
        <div>
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="px-4 py-2 text-sm font-medium text-white transition-all duration-300 border rounded-lg sm:px-6 sm:py-3 bg-white/10 hover:bg-white/20 backdrop-blur-sm border-white/20 hover:scale-105 hover:shadow-lg sm:text-base"
          >
            Back to Top
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
